export default __webpack_public_path__ + "static/hiit_it_interval_timer_iphone-complete@3x-a41fe64d24d935797d178673198580c7.webp";